<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                {value: null, text: $t('all')},
                {value: 'activated', text: $t('activated')},
                {value: 'deactivated', text: $t('deactivated')}
            ]"></form-select>
            <client-select v-if="!client" :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                            size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('smsBrandNameInfo') }}</div>
            <div class="col-lg-3">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <span v-if="item.client && item.client.companyName">{{ item.client.companyName }}</span>
              <span v-if="item.client && item.client.domain">({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-4">
              <div>
                <b>{{ $t('name') }}</b>: {{ item.name }}
                <span v-if="item.privateFee" class="badge badge-info">{{ $t('privateFee') }}</span>
              </div>
              <div v-if="item.username">
                <b>{{ $t('username') }}</b>: {{ item.username }}
              </div>
              <div v-if="item.gateway">
                <b>{{ $t('gateway') }}</b>: {{ item.gateway.name }}
              </div>
              <div>
                <b>{{ $t('fee') }}: </b>
                <span>{{ item.privateFee ? (item.fee ? item.fee : 0) : (item.gateway ? item.gateway.fee : 0) | numFormat }}</span>
              </div>
              <div>
                <b>{{ $t('monthlyFee') }}: </b>
                <span>{{
                    item.privateFee ? (item.monthlyFee ? item.monthlyFee : 0) : (item.gateway ? item.gateway.monthlyFee : 0) | numFormat
                  }}</span>
              </div>
              <div>
                <b>{{ $t('numberOfSms') }}: </b>
                <span>{{
                    item.privateFee ? (item.numberOfSms ? item.numberOfSms : 0) : (item.gateway ? item.gateway.numberOfSms : 0) | numFormat
                  }}</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.updateTime">
                <b>{{ $t('updateTime') }}: </b><span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.approveTime">
                <b>{{ $t('approveTime') }}: </b><span>{{ item.approveTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.denyTime">
                <b>{{ $t('denyTime') }}: </b><span>{{ item.denyTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div>
                <span class="badge badge-success" v-if="item.approveTime">{{ $t('approved') }}</span>
                <span class="badge badge-danger" v-else-if="item.denyTime">{{ $t('denied') }}</span>
                <!-- Cả hai mốc = 0 là hồ sơ mới chờ xử lý, trước đây cột này bỏ trống. -->
                <span class="badge badge-warning" v-else>{{ $t('waiting') }}</span>
              </div>

            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col"
                       v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)">
                    <button @click="update(item._id)" class="btn btn-info btn-sm mr-1" type="button">
                      <font-awesome-icon icon="edit"/>
                      {{ $t('edit') }}
                    </button>
                    <button v-if='!item.approveTime' @click="changeStatus(item._id, 'approve')"
                            class="btn btn-success btn-sm mr-1" type="button">
                      <font-awesome-icon icon="check"/>
                      {{ $t('activate') }}
                    </button>
                    <button v-if='!item.denyTime' @click="changeStatus(item._id, 'deny')"
                            class="btn btn-danger btn-sm mr-1" type="button">
                      <font-awesome-icon icon="window-close"/>
                      {{ $t('lock') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize"
                      @input="load"></b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" size="xl" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md">
          <div class="alert alert-warning">
            <div><b>Lưu ý Gateway Vietguys</b></div>
            <div>- Cần yêu cầu kỹ thuật vietguys add webhook <i class="text-primary">https://clientapi.phonenet.io/webhook/viber</i>
            </div>
            <div>- Sau khi thêm webhook, cần tự kiểm tra lại xác nhận thành công mới báo khách, thời gian gọi
              <b>webhook</b> là sau 24h
            </div>
            <div>- Tất cả đối soát thì sau 24h tính từ lúc gửi mới chính xác</div>
          </div>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-md">
              <client-select :label="$t('client')" :model="formModel" attribute="client"
                             :errors="formErrors"></client-select>
              <form-select :model="formModel" attribute="gateway" :options="gatewayOptions" :errors="formErrors"
                           label="Gateway"></form-select>
              <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
              <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>
              <form-checkbox :model="formModel" attribute="privateFee" :errors="formErrors"
                             :chk-label="$t('privateFee')"></form-checkbox>

              <form-input v-if="formModel.privateFee" :model="formModel" attribute="fee"
                          :label="$t('fee')" :errors="formErrors"></form-input>
              <form-input v-if="formModel.privateFee" :model="formModel" attribute="monthlyFee"
                          :label="$t('monthlyFee')"
                          :errors="formErrors"></form-input>
              <form-input v-if="formModel.privateFee" :model="formModel" attribute="numberOfSms"
                          :label="$t('numberOfSms')"
                          :errors="formErrors"></form-input>
            </div>
            <div class="col-md">
              <form-input :label="$t('username')" :model="formModel" attribute="username"
                          :errors="formErrors"></form-input>
              <form-input :label="$t('pwd')" :model="formModel" attribute="pwd" :errors="formErrors"></form-input>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button @click="showForm=false" class="btn btn-secondary">{{ $t('cancel') }}</button>
        <button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import ClientSelect from "@/components/ClientSelect";
import _ from 'lodash';
import moment from 'moment';

export default {
  props: {
    client: Object
  },
  mixins: [list, crud],
  components: {ClientSelect},
  data: function () {
    return {
      defaultFilterFormModel: {
        status: null,
        client: this.client ? this.client._id : null,
        keyword: null,
      },
      autoLoad: true,
      service: '/viber-brand-name',
      gatewayOptions: [],
      gateways: [],
      defaultFormModel: {
        client: this.client ? this.client._id : null,
        name: null,
        desc: null,
        gateway: null,
        username: null,
        pwd: null,
        privateFee: false,
        fee: null,
        unlimitedTemplateLength: null
      },
      formTitle: '',
      currentMonth: moment().format('MM/YYYY')
    }
  },
  watch: {},
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    smsTemplate(item) {
      this.$bus.$emit('smsTemplate', item);
    },
    changeStatus: function (id, type) {
      this.$swal({
        title: type === 'deny' ? this.$t('denyConfirm') : this.$t('approveConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service({
            url: this.service + '/change-status/' + id,
            method: 'put',
            data: {type: type}
          }).then(response => {
            if (response.data) {
              if (this.load) {
                this.load();
              }
              if (this.reloadBus) {
                this.$bus.$emit(this.reloadBus);
              }
              this.$swal({
                title: this.$t('success'),
                text: type === 'deny' ? this.$t('brandNameDenied') : this.$t('brandNameApproved'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    getGateways() {
      this.gatewayOptions = [{value: null, text: this.$t('chooseSMSGateway')}];
      this.$bgService.get('/viber-gateway/', {
        params: {
          page: 1,
          pageSize: 1000,
        }
      }).then(response => {
        this.gateways = response.data.docs;
        response.data.docs.forEach(item => {
          this.gatewayOptions.push({value: item._id, text: item.name});
        });
      })
    }
  },
  mounted() {
    this.getGateways();
    this.$bus.$on('loadViberBrandName', this.load)
  },
  beforeDestroy() {
    this.$bus.$off('loadViberBrandName')
  },
  i18n: {
    messages: {
      en: {
        type: "Type",
        smsTemplate: "Template",
        approved: "Approved",
        waiting: "Waiting",
        denied: "Denied",
        ads: "Ads",
        care: "Customer care",
        draft: "Draft",
        templateList: "Template list",
        approve: "Approve",
        deny: "Deny",
        cancel: "Cancel",
        fee: "Fee/SMS",
        denyConfirm: "Are you sure to deny this brand name?",
        smsBrandNameInfo: "Viber brand name info",
        chooseSMSGateway: "Choose Viber gateway",
        privateFee: "Private fee",
        brandNameApproved: "Brand name approved!",
        brandNameApprovedFailed: "Brand name approved failed",
        brandNameDenied: "Brand name denied!",
        brandNameDeniedFailed: "Brand name denied failed!",
        save: "Save",
        username: "Username",
        pwd: "Password",
        unlimitedTemplateLength: "Unlimited template length",
        approveBrandName: "Approve brand name",
        updateBrandName: "Update brand name",
        approveTime: "Approve time",
        denyTime: "Deny time",
        approveConfirm: "Are you sure to approve this brand name?",
        monthlyFee: 'Monthly advance fee',
        numberOfSms: "Number of messages/advance fee",
        unpaid: "Unpaid {0}",
        autoPayment: "Automatic payment",
        expired: "Expired"
      },
      vi: {
        type: "Loại",
        smsTemplate: "Mẫu",
        approved: "Đã duyệt",
        waiting: "Đợi duyệt",
        denied: "Đã từ chối",
        ads: "Quảng cáo",
        care: "CSKH",
        draft: "Nháp",
        templateList: "DS mẫu",
        approve: "Duyệt",
        deny: "Từ chối",
        cancel: "Huỷ",
        fee: "Giá/SMS",
        denyConfirm: "Bạn có chắc muốn khoá Viber Brand name này?",
        smsBrandNameInfo: "Thông tin Viber brand name",
        chooseSMSGateway: "Chọn Viber gateway",
        privateFee: "Bảng phí riêng",
        brandNameApproved: "Đã duyệt Viber brand name",
        brandNameApprovedFailed: "Duyệt Viber brand name thất bại",
        brandNameDenied: "Đã từ chối brand name!",
        brandNameDeniedFailed: "Từ chối brand name thất bại",
        save: "Lưu",
        username: "Tên đăng nhập",
        pwd: "Mật khẩu",
        unlimitedTemplateLength: "Không giới hạn độ dài template",
        approveBrandName: "Duyệt brand name",
        updateBrandName: "Cập nhật brand name",
        approveTime: "Kích hoạt lúc",
        denyTime: "Từ chối lúc",
        approveConfirm: "Bạn có chắc muốn kích hoạt brand name này?",
        monthlyFee: 'Hạn mức cam kết',
        numberOfSms: "Số tin cam kết",
        paymentTime: "Thanh toán",
        paymentRef: "Ref",
        unpaid: "Chưa thanh toán tháng {0}",
        autoPayment: "Tự động thanh toán hàng tháng",
        expired: "Hết hạn"
      }
    }
  }
}
</script>